"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var _enums = require("MeetingsBase/constants/enums");

function getInitialCustomFieldState(formFields) {
  return formFields.reduce(function (acc, field) {
    if (field.fieldType === _enums.FORM_FIELD_TYPES.BOOLEAN_CHECKBOX) {
      return acc.set(field.name, false);
    } else if (field.fieldType === _enums.FORM_FIELD_TYPES.CHECKBOX) {
      return acc.set(field.name, []);
    } else {
      return acc.set(field.name, null);
    }
  }, new _immutable.Map());
}

var defaults = {
  email: '',
  firstName: '',
  lastName: '',
  customFormFields: new _immutable.Map(),
  originalFormState: null
};

var FormState =
/*#__PURE__*/
function (_Record) {
  (0, _inherits2.default)(FormState, _Record);

  function FormState() {
    (0, _classCallCheck2.default)(this, FormState);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(FormState).apply(this, arguments));
  }

  (0, _createClass2.default)(FormState, null, [{
    key: "from",
    value: function from(json) {
      json.customFormFields = new _immutable.Map(json.customFormFields);
      var jsonMap = (0, _immutable.Map)(json).filter(function (value) {
        return value !== undefined;
      });
      return new FormState(jsonMap);
    }
  }, {
    key: "customFieldsFromBookInfo",
    value: function customFieldsFromBookInfo(json) {
      var formFields = json.customParams.formFields;
      var customFormFields = getInitialCustomFieldState(formFields);
      return customFormFields;
    }
  }]);
  return FormState;
}((0, _immutable.Record)(defaults));

exports.default = FormState;
module.exports = exports.default;